import { render, staticRenderFns } from "./z-page.vue?vue&type=template&id=5ae58320&scoped=true"
import script from "./z-page.vue?vue&type=script&lang=ts"
export * from "./z-page.vue?vue&type=script&lang=ts"
import style0 from "./z-page.vue?vue&type=style&index=0&id=5ae58320&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae58320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae58320')) {
      api.createRecord('5ae58320', component.options)
    } else {
      api.reload('5ae58320', component.options)
    }
    module.hot.accept("./z-page.vue?vue&type=template&id=5ae58320&scoped=true", function () {
      api.rerender('5ae58320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/z-page.vue"
export default component.exports